<template>
  <v-app light>
    <main-navigation></main-navigation>
    <v-content>
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-content>
    <div class="overlay" v-if="loader > 0" :value="true">
      <v-progress-circular indeterminate size="64" color="mari"></v-progress-circular>
      <div v-if="loaderText.length > 0" class="loader-text" v-text="translate[loaderText][lang]"></div>
    </div>
  </v-app>
</template>

<script>
import navigationMain from '@/components/navigation/Main'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    'main-navigation': navigationMain
  },
  created () {
    this.getWpPages()
  },
  computed: {
    ...mapGetters(['loader', 'lang', 'translate', 'loaderText'])
  },
  methods: {
    ...mapActions(['getWpPages'])
  }
}
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.loader-text {
  max-width: 80ch;
  padding: 1.5rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue